import {
    FC,
    FormEvent,
    ReactElement,
    useRef,
    useState,
} from 'react'

import { FormActionButtons } from '../../../compositions'
import trans from '../../../helpers/trans'
import { ModalFormProps } from '../../../types/modalFormTypes'

import './DeleteDistrictDivisionTemplateForm.scss'

interface DeleteDistrictDivisionTemplateFormProps extends ModalFormProps<{ id: string }> {
    districtDivisionTemplateId: string;
}

const DeleteDistrictDivisionTemplateForm: FC<DeleteDistrictDivisionTemplateFormProps> = ({
    isLoading,
    districtDivisionTemplateId,
    onSubmit,
    onCancel,
}): ReactElement => {
    const [formData, setFormData] = useState({ id: districtDivisionTemplateId })

    const formRef = useRef<HTMLFormElement>(null)

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const formDataToSubmit = { id: formData.id }
        setFormData(formDataToSubmit)

        onSubmit(formDataToSubmit)
    }

    return (
        <form ref={formRef} onSubmit={handleSubmit} className="delete-district-division-template-form">
            <div className="delete-district-division-template-form__row">
                <div className="delete-district-division-template-form__col">
                    <p>{trans('containers.forms.deleteDistrictDivisionTemplateForm.deleteDistrictDivisionTemplate')}</p>
                </div>
            </div>
            <FormActionButtons
                isLoading={isLoading}
                submitText={trans('common.delete')}
                onCancelClick={onCancel}
            />
        </form>
    )
}

export default DeleteDistrictDivisionTemplateForm
